<template>
    <div>
        <slot
            v-if="!is_open"
            name="short"
        />

        <slot
            v-else
            name="long"
        />

        <slot
            name="trigger"
            :is-open="is_open"
            :open="open"
            :close="close"
            :toggle="toggle"
        />
    </div>
</template>

<script>
    export default {
        data () {
            return {
                is_open: false
            }
        },
        methods: {
            open () {
                this.is_open = true
            },
            close () {
                this.is_open = false
            },
            toggle () {
                this.is_open ? this.close() : this.open()
            }
        }
    }
</script>
